import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import enhancer from '../enhancer';

import Grid from '../grid/Grid';

class Grades extends Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.code}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Code']}
          rows={master.allGrades.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query GradesAdminQuery {
    master {
      ...Grades_master
    }
  }
`;

export default enhancer(Grades, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Grades, {
        master: graphql`
          fragment Grades_master on Master {
            allGrades(first: 10) {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Grades.js